import useTranslation from "../../../../hooks/i18n/useTranslation";
import "../../styles/Settings.css";
import { TextHeader } from "../../components/text-header/TextHeader";
import { HeightSelector } from "../../components/height-selector/HeightSelector";
import { WeightSelector } from "../../components/weight-selector/WeightSelector";
import { useSettings } from "../../hooks/useSettings";

export const Units = () => {
  const { t } = useTranslation();
  const {
    units,
    preferencesLoading,
    updateUserLengthUnit,
    updateUserWeightUnit,
  } = useSettings();

  return (
    <div className="settings-container-item settings-container-units">
      <TextHeader title={t("275")} content={t("276")} />
      <div className="settings-region-content">
        <HeightSelector
          unit={units.length}
          onUnitChange={updateUserLengthUnit}
          disabled={preferencesLoading}
        />
        <WeightSelector
          unit={units.weight}
          onUnitChange={updateUserWeightUnit}
          disabled={preferencesLoading}
        />
      </div>
    </div>
  );
};
